/**
 * Ячейка-флаг (§5.2, тип «Флаг»): «категории не уточнены» и пользовательские
 * bool. Space и Enter переключают значение сразу, без редактора — правка
 * уходит в черновик.
 */
import { IconCheck, IconWarning } from '../../../../components/index.js'
import { tableTexts as t } from '../../texts.table.js'
import type { CellProps } from './CellBox.js'

export function BoolCell({ column, cell }: CellProps) {
  const on = cell.value === true
  if (column.source.kind === 'brand' && column.source.field === 'categoriesUnclear') {
    return on
      ? <span className="cell__flag" aria-label={t.column.unclear}><IconWarning size={16} /></span>
      : <span className="cell__dash" aria-hidden="true">{t.empty.dash}</span>
  }
  return on
    ? <span className="cell__flag cell__flag--on" aria-label={column.title}><IconCheck size={16} /></span>
    : <span className="cell__dash" aria-hidden="true">{t.empty.dash}</span>
}
